export default {
  allowVideo: false,
  allowSocial: false,
  allowHtml: true,
  allowAlignment: true,
  allowAnchorEditorHeader: true
};